import React, { useMemo, useState } from "react";
import { Card, CardHeader, CardBody, Badge } from "reactstrap";
import DataTable from "./Datatable";

const formatDate = (value) => {
  if (!value) return "-";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const formatList = (arr) =>
  Array.isArray(arr) && arr.length > 0 ? arr.join(", ") : "-";

/**
 * Displays branch user details (the single "branchuser" object from the
 * company details API) inside the shared DataTable shell.
 *
 * Excludes: password, created_by, uid, and boolean flags
 * (isAdmin, isDeleted, isVerify) per requirements.
 *
 * Props:
 * - branchUser: object - the branchuser record from the API response
 */
const BranchUserTable = ({ branchUser }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const data = useMemo(() => {
    if (!branchUser) return [];
    if (!searchTerm.trim()) return [branchUser];

    const term = searchTerm.toLowerCase();
    const matches = [
      branchUser.first_name,
      branchUser.last_name,
      branchUser.email,
      branchUser.phone,
      branchUser.role,
      branchUser.status,
    ]
      .filter(Boolean)
      .some((field) => field.toLowerCase().includes(term));

    return matches ? [branchUser] : [];
  }, [branchUser, searchTerm]);

  const columns = [
    {
      dataField: "first_name",
      text: "First Name",
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "last_name",
      text: "Last Name",
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "email",
      text: "Email",
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "phone",
      text: "Phone",
      formatter: (cell, row) =>
        (row.phonecountrycode || "+91") + " " + (cell || "-"),
    },
    {
      dataField: "role",
      text: "Role",
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "branch_name",
      text: "Branch",
      formatter: (cell) => (cell),
    },
  ];

  return (
    <Card className="shadow-sm border-0 mt-4">
      <CardHeader className="bg-white border-bottom py-3">
        <h5 className="mb-0">Branch User Details</h5>
      </CardHeader>
      <CardBody>
        <DataTable
          keyField="_id"
          columns={columns}
          data={data}
          page={1}
          totalPages={1}
          onPageChange={() => {}}
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
          loading={false}
          searchPlaceholder="Search branch user..."
        />
      </CardBody>
    </Card>
  );
};

export default BranchUserTable;